import { defineRecipe } from '@chakra-ui/react'

/**
 * Optional paywall presentations; the default mirrors the Advisors upgrade cards. Each card spans
 * four rows of its grid's subgrid (header, price, action, lines) so side-by-side plans line up
 * their names, prices, and CTAs whatever the copy length.
 */
export const paywallProductCardRecipe = defineRecipe({
  className: 'sco-paywall-product-card',
  base: {
    alignContent: 'start',
    bg: 'colorPalette.bg',
    borderColor: 'border',
    borderRadius: 'lg',
    borderWidth: '1px',
    display: 'grid',
    gridRow: 'span 4',
    gridTemplateRows: 'subgrid',
    h: 'full',
    p: { base: 5, md: 6 },
    position: 'relative',
    rowGap: 5,
    w: 'full',
  },
  variants: {
    appearance: {
      standard: {},
      spotlight: {
        bg: 'bg.panel',
        borderColor: 'border.emphasized',
        p: { base: 6, md: 8 },
        rowGap: 6,
      },
      quiet: {
        bg: 'bg.panel',
        rowGap: 4,
      },
    },
    recommended: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      appearance: 'standard',
      recommended: true,
      css: {
        bg: 'colorPalette.card/50',
        borderColor: 'orange.solid',
        borderWidth: '2px',
      },
    },
    {
      appearance: 'spotlight',
      recommended: true,
      css: {
        bg: 'colorPalette.card/50',
        borderColor: 'orange.solid',
        borderWidth: '2px',
        boxShadow: 'lg',
      },
    },
    {
      appearance: 'quiet',
      recommended: true,
      css: {
        bg: 'colorPalette.container/50',
        borderColor: 'colorPalette.border',
      },
    },
  ],
  defaultVariants: {
    appearance: 'standard',
    recommended: false,
  },
})
